// LIVE-PRODUCT-VIDEO-AUTO-GENERATE-1 · 상품영상 자동 생성 상태 문구 (recording-overview 실제 값 기준).
export const autoGenLabel = (ov) => {
  if (!ov || !ov.recording_enabled) return null;
  if (!ov.recording_auto_split) return { tone: 'gray', text: '상품영상 자동 생성 OFF · 녹화 완료 후 상품영상 관리에서 직접 생성할 수 있어요.' };
  if (!ov.auto_split_enabled) return { tone: 'gray', text: '자동 생성 선택됨 · 현재 Preview 자동 생성 기능이 꺼져 있어요(관리 설정) · 직접 생성은 가능해요.' };
  const st = ov.session?.recording?.status;
  if (!st) return { tone: 'gray', text: '방송 종료 후 녹화 저장이 완료되면 상품영상이 자동 생성돼요.' };
  if (st === 'STARTING' || st === 'RECORDING') return { tone: 'gray', text: '녹화 중 · 방송 종료 후 상품영상이 자동 생성돼요.' };
  if (st === 'STOPPING') return { tone: 'amber', text: '원본 저장 확인 중 · 완료되면 상품영상 생성을 시작해요.' };
  if (st !== 'COMPLETED') return { tone: 'red', text: '녹화 원본이 완료되지 않아 상품영상을 만들 수 없어요.' };
  if (!ov.session_auto_split) return { tone: 'gray', text: '이 녹화는 자동 생성 대상이 아니에요 · 상품영상 관리에서 직접 생성할 수 있어요.' };
  const c = ov.segments || {};
  const failed = (c.FAILED || 0) + (c.FAILED_FINAL || 0);
  if (!c.total) return { tone: 'gray', text: '기록된 상품 소개 구간이 없어요.' };
  if (c.READY === c.total) return { tone: 'green', text: `상품영상 전체 READY (${c.READY}개)` };
  if (c.PROCESSING) return { tone: 'amber', text: `상품영상 생성 중 (${c.READY}/${c.total} READY)` };
  if (failed) return { tone: 'red', text: `일부 상품영상 생성 실패 ${failed}개 (${c.READY}/${c.total} READY) · 상품영상 관리에서 확인해 주세요.` };
  return { tone: 'amber', text: `상품영상 자동 생성 대기 (${c.READY}/${c.total} READY)` };
};
